export default "__VITE_ASSET__973f45d9__"